(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pen-closing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pen-purchase-scroll')) {
  customElements.define('pen-purchase-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.onPurchaseClick) return;
      this.onPurchaseClick = (event) => {
        const link = event.target.closest('[data-pen-purchase-link]');
        if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1)) ||
          document.querySelector('[id^="MainProduct-"]')?.closest('.shopify-section');
        if (!target) return;
        event.preventDefault();
        const viewport = window.visualViewport;
        const viewportHeight = viewport ? viewport.height : window.innerHeight;
        const viewportOffset = viewport ? viewport.offsetTop : 0;
        const rect = target.getBoundingClientRect();
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const top = Math.min(maxScroll, Math.max(0,
          window.scrollY + rect.bottom - viewportOffset - viewportHeight
        ));
        target.querySelector('button[name="add"]')?.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      this.addEventListener('click', this.onPurchaseClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onPurchaseClick);
      this.onPurchaseClick = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pen-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pen-product')) {
  customElements.define('pen-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-pen-thumb]');
        if (!thumb) return;
        this.querySelectorAll('[data-pen-slide]').forEach((slide) => { slide.hidden = slide.dataset.penSlide !== thumb.dataset.penThumb; });
        this.querySelectorAll('[data-pen-thumb]').forEach((button) => { const active = button === thumb; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
      });
      this.addEventListener('change', (event) => {
        const picker = event.target.closest('variant-selects');
        if (!picker || !this.contains(picker)) return;
        event.stopImmediatePropagation();
        const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
        const choices = Array.from(picker.querySelectorAll('.product-form__input')).map(group => {
          const selected = group.querySelector('select, input[type="radio"]:checked');
          return selected ? selected.value : null;
        });
        const variant = variants.find(item => item.options.every((option, index) => option === choices[index]));
        const button = this.querySelector('button[name="add"]');
        const input = this.querySelector('input.product-variant-id');
        if (!variant) { if (button) button.disabled = true; if (input) input.disabled = true; return; }
        if (input) { input.value = variant.id; input.disabled = false; input.dispatchEvent(new Event('change', {bubbles:true})); }
        const prices = JSON.parse(this.querySelector('[data-native-variant-prices]').textContent);
        const priceDisplay = this.querySelector('[data-pen-price]');
        if (priceDisplay) priceDisplay.textContent = prices[String(variant.id)];
        if (button) {
          button.disabled = !variant.available;
          const label = button.querySelector('.main-atc__label');
          if (label) label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
          button.dataset.unavailable = String(!variant.available);
        }
        picker.currentVariant = variant;
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      }, true);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pen-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pen-product')) {
  customElements.define('pen-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-pen-thumb]');
        if (!thumb) return;
        this.querySelectorAll('[data-pen-slide]').forEach((slide) => { slide.hidden = slide.dataset.penSlide !== thumb.dataset.penThumb; });
        this.querySelectorAll('[data-pen-thumb]').forEach((button) => { const active = button === thumb; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
      });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="pen_variant"]')) return;
        const selected = event.target;
        const available = selected.dataset.available === 'true';
        this.querySelector('[data-pen-price]').textContent = selected.dataset.price;
        const variantInput = this.querySelector('input.product-variant-id');
        variantInput.value = selected.value;
        variantInput.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.querySelector('button[name=add]');
        button.disabled = !available;
        button.querySelector('.main-atc__label').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        button.dataset.unavailable = String(!available);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed-closing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seed-purchase-scroll')) {
  customElements.define('seed-purchase-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.onPurchaseClick) return;
      this.onPurchaseClick = (event) => {
        const link = event.target.closest('[data-seed-purchase-link]');
        if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1)) ||
          document.querySelector('[id^="MainProduct-"]')?.closest('.shopify-section');
        if (!target) return;
        event.preventDefault();
        const viewport = window.visualViewport;
        const viewportHeight = viewport ? viewport.height : window.innerHeight;
        const viewportOffset = viewport ? viewport.offsetTop : 0;
        const rect = target.getBoundingClientRect();
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const top = Math.min(maxScroll, Math.max(0,
          window.scrollY + rect.bottom - viewportOffset - viewportHeight
        ));
        target.querySelector('button[name="add"]')?.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      this.addEventListener('click', this.onPurchaseClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onPurchaseClick);
      this.onPurchaseClick = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('seed-product')) {
  customElements.define('seed-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-seed-thumb]');
        if (!thumb) return;
        this.querySelectorAll('[data-seed-slide]').forEach((slide) => { slide.hidden = slide.dataset.seedSlide !== thumb.dataset.seedThumb; });
        this.querySelectorAll('[data-seed-thumb]').forEach((button) => { const active = button === thumb; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
      });
      this.addEventListener('change', (event) => {
        const picker = event.target.closest('variant-selects');
        if (!picker || !this.contains(picker)) return;
        event.stopImmediatePropagation();
        const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
        const choices = Array.from(picker.querySelectorAll('.product-form__input')).map(group => {
          const selected = group.querySelector('select, input[type="radio"]:checked');
          return selected ? selected.value : null;
        });
        const variant = variants.find(item => item.options.every((option, index) => option === choices[index]));
        const button = this.querySelector('button[name="add"]');
        const input = this.querySelector('input.product-variant-id');
        if (!variant) { if (button) button.disabled = true; if (input) input.disabled = true; return; }
        if (input) { input.value = variant.id; input.disabled = false; input.dispatchEvent(new Event('change', {bubbles:true})); }
        const prices = JSON.parse(this.querySelector('[data-native-variant-prices]').textContent);
        this.querySelector('[data-seed-price]').textContent = prices[String(variant.id)];
        if (button) {
          button.disabled = !variant.available;
          const label = button.querySelector('.main-atc__label');
          if (label) label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
          button.dataset.unavailable = String(!variant.available);
        }
        picker.currentVariant = variant;
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      }, true);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seed-product')) {
  customElements.define('seed-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-seed-thumb]');
        if (!thumb) return;
        this.querySelectorAll('[data-seed-slide]').forEach((slide) => { slide.hidden = slide.dataset.seedSlide !== thumb.dataset.seedThumb; });
        this.querySelectorAll('[data-seed-thumb]').forEach((button) => { const active = button === thumb; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
      });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="seed_variant"]')) return;
        const selected = event.target;
        const available = selected.dataset.available === 'true';
        this.querySelector('[data-seed-price]').textContent = selected.dataset.price;
        const variantInput = this.querySelector('input.product-variant-id');
        variantInput.value = selected.value;
        variantInput.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.querySelector('button[name=add]');
        button.disabled = !available;
        button.querySelector('.main-atc__label').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        button.dataset.unavailable = String(!available);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed2-closing"] && !Shopify.designMode) return;
  try {
    
if (!window.seed2ScrollBound) {
  window.seed2ScrollBound = true;
  document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-seed2-scroll]');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height : window.innerHeight;
    const offset = viewport ? viewport.offsetTop : 0;
    const max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const top = Math.min(max, Math.max(0, window.scrollY + target.getBoundingClientRect().bottom - offset - height));
    target.querySelector('button[name="add"]')?.focus({preventScroll:true});
    window.scrollTo({top, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
}

  } catch(e) { console.error(e); }
})();
})();
